import React from 'react';
import styles from './styles.module.scss';

import cn from 'classnames';

const Column = ({ className, center, ...props }) => (
  <div className={cn(styles.column, className, props.styles)} style={props.style} {...props}>
    {props.children}
  </div>
);

export default Column;
